export default __webpack_public_path__ + "static/media/gothenburg_xl3.e0ace65c.png";